import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['customInput', 'hiddenInput', 'select']

  toggle() {
    const isCustom = this.selectTarget.value === 'custom'

    this.customInputTarget.style.display = isCustom ? 'block' : 'none'

    if (isCustom) {
      const customField = this.customInputTarget.querySelector('input')
      if (customField && !customField.value) {
        customField.value = this.hiddenInputTarget.value
      }
    } else {
      this.hiddenInputTarget.value = this.selectTarget.value
    }
  }

  updateHiddenInput() {
    this.hiddenInputTarget.value = this.customInputTarget.querySelector('input')?.value
  }
}
